import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=c7efb62a&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=ts&"
export * from "./Comments.vue?vue&type=script&lang=ts&"
import style0 from "./Comments.vue?vue&type=style&index=0&id=c7efb62a&lang=scss&scoped=true&"
import style1 from "./Comments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7efb62a",
  null
  
)

export default component.exports